import http from '../api'
import { User, InputCreateUser, InputUpdateUser, Pagination, UserFilters } from './types'
import { PaginatedResponse } from '../api/types'

async function getUsers(pagination: Pagination, filters: UserFilters) {
  return await http.get<PaginatedResponse<User[]>>(
    `user?page=${pagination.page}&limit=${pagination.perPage}&isAttributed=${filters.isAttributed}&search=${filters.search}`,
  )
}

async function deleteUser(id: number) {
  return await http.delete<boolean>(`user/${id}`)
}

async function createUser(input: InputCreateUser) {
  return await http.post<User>('user', input)
}

async function updateUser(id: number, input: InputUpdateUser) {
  return await http.patch<User>(`user/${id}`, input)
}

async function confirmUser(id: number) {
  return await http.post<User>(`user/confirm/${id}`)
}

export default {
  getUsers,
  createUser,
  updateUser,
  confirmUser,
  deleteUser,
}
